import React, { Dispatch, SetStateAction, useMemo } from 'react';
import { Dropdown, Checkbox, ListItemProps } from '@silverfort/sf-components';

interface Props {
    categories: string[];
    selectedCategories: string[];
    setSelectedCategories: Dispatch<SetStateAction<string[] | undefined>>;
    showOnlyActive: boolean;
    setShowOnlyActive: (show: boolean) => void;
}

const ExposuresFilters: React.FC<Props> = ({
    categories,
    selectedCategories,
    setSelectedCategories,
    showOnlyActive,
    setShowOnlyActive
}) => {
    const categoryItems = useMemo<ListItemProps<string>[]>(() => {
        return categories
            .filter((c) => c !== 'All')
            .map((category) => ({
                title: category,
                value: category
            }));
    }, [categories]);

    return (
        <div className="flex items-center gap-4">
            <Dropdown
                variant="filter"
                title="Exposures category"
                items={categoryItems}
                menuClassName="w-[200px]"
                searchable
                multiple
                selectedItems={selectedCategories}
                onChange={(val) => {
                    if (Array.isArray(val)) setSelectedCategories(val as string[]);
                    else if (typeof val === 'string') setSelectedCategories([val]);
                    else setSelectedCategories(undefined);
                }}
                removable={!!selectedCategories?.length}
                onRemove={() => setSelectedCategories(undefined)}
            />

            <div className="flex items-center gap-2 text-sm text-sf-gray-700">
                <Checkbox checked={showOnlyActive} onChange={(e) => setShowOnlyActive(e.target.checked)} />
                Show only active
            </div>
        </div>
    );
};

export default ExposuresFilters;
